{
  "worshipSongs": "Worship Songs",
  "playlists": "Playlists",
  "songCount_one": "{{count}} song",
  "songCount_other": "{{count}} songs"
}
